import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { StorageHandler } from 'C4';
import { storageKeys } from 'settings';

export default class BackImage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      image: null,
    };
  }

  componentDidMount() {
    this.loadBgImage();
  }

  async loadBgImage() {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      this.setState({
        image: appInfo.backgroundImage ? appInfo.backgroundImage : null,
        size: {
          width: document.body.clientWidth,
          height: document.body.clientHeight,
        },
      });
    }
  }

  render() {
    const { image, size } = this.state;
    const { blur, darken } = this.props;

    let imgixUrl = image;
    if (image) { imgixUrl = `${image.replace('front.travpromobile.com', 'travprocdn.imgix.net')}?width=${size.width}`; }
    return (
      <div className="bgImage">
        {image && (
          <div
            style={{ backgroundImage: `url("${imgixUrl}")` }}
            className={`backgroundImage ${blur && 'blur'} ${
              darken && 'darken'
            }`}
          />
        )}
      </div>
    );
  }
}

BackImage.propTypes = {
  blur: PropTypes.bool,
  darken: PropTypes.bool,
};

BackImage.defaultProps = {
  blur: false,
  darken: false,
};
